import React, { useState, useEffect, useContext} from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Menu from "../include/Menu";
import Footer from "../include/Footer";
import Modal from 'react-modal';
import AddLiquidity from "./AddLiquidity.js";
import RemoveLiquidity from "./RemoveLiquidity.js";
import Swal  from "sweetalert2";
import AOS from "aos";
import "aos/dist/aos.css";
import Context from "../../../context/context";
import Web3 from "web3";
import Token from '../abi/Ufo.json';
import UFOpTGCContract from '../abi/Ptgc.json';
import UFOHEXContract from '../abi/Hex.json';
import UFOHEXETHContract from '../abi/HexEth.json';
import UFOINCContract from '../abi/Inc.json';
import UFOPLSXContract from '../abi/Plsx.json';
import UFOPLSContract from '../abi/Pls.json';
import UFODAIContract from '../abi/Dai.json';
import UFOContract from '../abi/Ufo.json';
import StakingContract from '../abi/Staking.json';
import { formatUnits } from "ethers";
import TransactionStatus from "../TxnStatus";
import { providerURL, txAfterDone, txDone, txStart } from '../../../helper/Helper';

const IndexSections = () => {
  const {account, onConnect, providers, ufoPrice} = useContext(Context);
  const [addLiquidityModalOpen, setAddLiquidityModalOpen] = useState(false);
  const [removeLiquidityModalOpen, setRemoveLiquidityModalOpen] = useState(false);
  const [copyaddress, setCopyaddress] = useState('00');
  const [mymodalIsOpen, setIsOpen] = React.useState(false);
  const [isInSection, setIsInSection] = useState(false);

  const [refresh, setRefresh] = useState(false);
  const [UFOpTGC, setUFOpTGC] = useState({UFO:0, pTGC:0, supply:'0', balance:0, address:0});
  const [UFOHEX, setUFOHEX] = useState({UFO:0, HEX:0, supply:0, balance:0, balance:0, address:0});
  const [UFOHEXETH, setUFOHEXETH] = useState({UFO:0, HEXETH:0, supply:0, balance:0, balance:0, address:0});
  const [UFOINC, setUFOINC] = useState({UFO:0, INC:0, supply:0, balance:0, balance:0, address:0});
  const [UFOPLSX, setUFOPLSX] = useState({UFO:0, PLSX:0, supply:0, balance:0, balance:0, address:0});
  const [UFOPLS, setUFOPLS] = useState({UFO:0, PLS:0, supply:0, balance:0, balance:0, address:0});
  const [UFODAI, setUFODAI] = useState({UFO:0, DAI:0, supply:0, balance:0, balance:0, address:0});

  const [currentPair, setCurrentPair] = useState('UFO_UFO');
  const [currentBalance, setCurrentBalance] = useState(0);
  const [currentSupply, setCurrentSupply] = useState(0);

  useEffect(() => {
    getData()
  }, [refresh, account]);

  const getData = async () => {
    const web3 = new Web3(providerURL());

    const UFOpTGCInstance = new web3.eth.Contract(UFOpTGCContract.ABI, UFOpTGCContract.Contract);
    const UFOHEXInstance = new web3.eth.Contract(UFOHEXContract.ABI, UFOHEXContract.Contract);
    const UFOHEXETHInstance = new web3.eth.Contract(UFOHEXETHContract.ABI, UFOHEXETHContract.Contract);
    const UFOINCInstance = new web3.eth.Contract(UFOINCContract.ABI, UFOINCContract.Contract);
    const UFOPLSXInstance = new web3.eth.Contract(UFOPLSXContract.ABI, UFOPLSXContract.Contract);
    const UFOPLSInstance = new web3.eth.Contract(UFOPLSContract.ABI, UFOPLSContract.Contract);
    const UFODAIInstance = new web3.eth.Contract(UFODAIContract.ABI, UFODAIContract.Contract);

    let UFOpTGCBalance = 0;
    let UFOHEXBalance = 0;
    let UFOHEXETHBalance = 0;
    let UFOINCBalance = 0;
    let UFOPLSXBalance = 0;
    let UFOPLSBalance = 0;
    let UFODAIBalance = 0;
    if(account)
    {
         UFOpTGCBalance = Number(formatUnits(await UFOpTGCInstance.methods.balanceOf(account).call(), 18));
         UFOHEXBalance = Number(formatUnits(await UFOHEXInstance.methods.balanceOf(account).call(), 18));
         UFOHEXETHBalance = Number(formatUnits(await UFOHEXETHInstance.methods.balanceOf(account).call(), 18));
         UFOINCBalance = Number(formatUnits(await UFOINCInstance.methods.balanceOf(account).call(), 18));
         UFOPLSXBalance = Number(formatUnits(await UFOPLSXInstance.methods.balanceOf(account).call(), 18));
         UFOPLSBalance = Number(formatUnits(await UFOPLSInstance.methods.balanceOf(account).call(), 18));
         UFODAIBalance = Number(formatUnits(await UFODAIInstance.methods.balanceOf(account).call(), 18));
    }

    let UFOpTGCShare = await UFOpTGCInstance.methods.getReserves().call();
    let UFOpTGCSupply = Number(formatUnits(await UFOpTGCInstance.methods.totalSupply().call(), 18));
    let token0 = await UFOpTGCInstance.methods.token0().call();
    let token1 = await UFOpTGCInstance.methods.token1().call();

    const newUFOpTGC = { ...UFOpTGC };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFOpTGC.pTGC = parseInt(UFOpTGCShare._reserve1);
             newUFOpTGC.UFO = parseInt(UFOpTGCShare._reserve0);
          }
          else
          {
             newUFOpTGC.pTGC = parseInt(UFOpTGCShare._reserve0);
             newUFOpTGC.UFO = parseInt(UFOpTGCShare._reserve1);
          }
          newUFOpTGC.supply = UFOpTGCSupply;
          newUFOpTGC.balance = UFOpTGCBalance;
          newUFOpTGC.address = UFOpTGCContract.Contract;
          setUFOpTGC(newUFOpTGC);

    let UFOHEXShare = await UFOHEXInstance.methods.getReserves().call();
    let UFOHEXSupply = Number(formatUnits(await UFOHEXInstance.methods.totalSupply().call(), 18));
    token0 = await UFOHEXInstance.methods.token0().call();
    token1 = await UFOHEXInstance.methods.token1().call();

    const newUFOHEX = { ...UFOHEX };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFOHEX.HEX = parseInt(UFOHEXShare._reserve1);
             newUFOHEX.UFO = parseInt(UFOHEXShare._reserve0);
          }
          else
          {
             newUFOHEX.HEX = parseInt(UFOHEXShare._reserve0);
             newUFOHEX.UFO = parseInt(UFOHEXShare._reserve1);
          }
          newUFOHEX.supply = UFOHEXSupply;
          newUFOHEX.balance = UFOHEXBalance;
          newUFOHEX.address = UFOHEXContract.Contract;
          setUFOHEX(newUFOHEX);

    let UFOHEXETHShare = await UFOHEXETHInstance.methods.getReserves().call();
    let UFOHEXETHSupply = Number(formatUnits(await UFOHEXETHInstance.methods.totalSupply().call(), 18));
    token0 = await UFOHEXETHInstance.methods.token0().call();
    token1 = await UFOHEXETHInstance.methods.token1().call();

    const newUFOHEXETH = { ...UFOHEXETH };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFOHEXETH.HEXETH = parseInt(UFOHEXETHShare._reserve1);
             newUFOHEXETH.UFO = parseInt(UFOHEXETHShare._reserve0);
          }
          else
          {
             newUFOHEXETH.HEXETH = parseInt(UFOHEXETHShare._reserve0);
             newUFOHEXETH.UFO = parseInt(UFOHEXETHShare._reserve1);
          }
          newUFOHEXETH.supply = UFOHEXETHSupply;
          newUFOHEXETH.balance = UFOHEXETHBalance;
          newUFOHEXETH.address = UFOHEXETHContract.Contract;
          setUFOHEXETH(newUFOHEXETH);

    let UFOINCShare = await UFOINCInstance.methods.getReserves().call();
    let UFOINCSupply = Number(formatUnits(await UFOINCInstance.methods.totalSupply().call(), 18));
    token0 = await UFOINCInstance.methods.token0().call();
    token1 = await UFOINCInstance.methods.token1().call();

    const newUFOINC = { ...UFOINC };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFOINC.INC = parseInt(UFOINCShare._reserve1);
             newUFOINC.UFO = parseInt(UFOINCShare._reserve0);
          }
          else
          {
             newUFOINC.INC = parseInt(UFOINCShare._reserve0);
             newUFOINC.UFO = parseInt(UFOINCShare._reserve1);
          }
          newUFOINC.supply = UFOINCSupply;
          newUFOINC.balance = UFOINCBalance;
          newUFOINC.address = UFOINCContract.Contract;
          setUFOINC(newUFOINC);

    let UFOPLSXShare = await UFOPLSXInstance.methods.getReserves().call();
    let UFOPLSXSupply = Number(formatUnits(await UFOPLSXInstance.methods.totalSupply().call(), 18));
    token0 = await UFOPLSXInstance.methods.token0().call();
    token1 = await UFOPLSXInstance.methods.token1().call();

    const newUFOPLSX = { ...UFOPLSX };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
              newUFOPLSX.PLSX = parseInt(UFOPLSXShare._reserve1);
              newUFOPLSX.UFO = parseInt(UFOPLSXShare._reserve0);
          }
          else
          {
             newUFOPLSX.PLSX = parseInt(UFOPLSXShare._reserve0);
             newUFOPLSX.UFO = parseInt(UFOPLSXShare._reserve1);
          }
          newUFOPLSX.supply = UFOPLSXSupply;
          newUFOPLSX.balance = UFOPLSXBalance;
          newUFOPLSX.address = UFOPLSXContract.Contract;
          setUFOPLSX(newUFOPLSX);

    let UFOPLSShare = await UFOPLSInstance.methods.getReserves().call();
    let UFOPLSSupply = Number(formatUnits(await UFOPLSInstance.methods.totalSupply().call(), 18));
    token0 = await UFOPLSInstance.methods.token0().call();
    token1 = await UFOPLSInstance.methods.token1().call();

    const newUFOPLS = { ...UFOPLS };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFOPLS.PLS = parseInt(UFOPLSShare._reserve1);
             newUFOPLS.UFO = parseInt(UFOPLSShare._reserve0);
          }
          else
          {
             newUFOPLS.PLS = parseInt(UFOPLSShare._reserve0);
             newUFOPLS.UFO = parseInt(UFOPLSShare._reserve1);
          }
          newUFOPLS.supply = UFOPLSSupply;
          newUFOPLS.balance = UFOPLSBalance;
          newUFOPLS.address = UFOPLSContract.Contract;
          setUFOPLS(newUFOPLS);

    let UFODAIShare = await UFODAIInstance.methods.getReserves().call();
    let UFODAISupply = Number(formatUnits(await UFODAIInstance.methods.totalSupply().call(), 18));
    token0 = await UFODAIInstance.methods.token0().call();
    token1 = await UFODAIInstance.methods.token1().call();

    const newUFODAI = { ...UFODAI };
          if(token0.toLowerCase() === UFOContract.Contract.toLowerCase())
          {
             newUFODAI.DAI = parseInt(UFODAIShare._reserve1);
             newUFODAI.UFO = parseInt(UFODAIShare._reserve0);
          }
          else
          {
             newUFODAI.DAI = parseInt(UFODAIShare._reserve0);
             newUFODAI.UFO = parseInt(UFODAIShare._reserve1);
          }
          newUFODAI.supply = UFODAISupply;
          newUFODAI.balance = UFODAIBalance;
          newUFODAI.address = UFODAIContract.Contract;
          setUFODAI(newUFODAI);      
  }

  const addLiquidity = async(pair) => {
    setCurrentPair(pair);
    setAddLiquidityModalOpen(true);
  };

  const removeLiquidity = async (pair) => {
    setCurrentPair(pair);
    setRemoveLiquidityModalOpen(true);
  };

  const closeAddLiquidityModal = () => setAddLiquidityModalOpen(false);
  const closeRemoveLiquidityModal = () => setRemoveLiquidityModalOpen(false);

  useEffect(() => {
    const section = document.querySelector(".ProposalSec");
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInSection(entry.isIntersecting);
      },
      { threshold: 0.5 }
    );
    if (section) {
      observer.observe(section);
    }
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const updatePage = () => {
    setRefresh(!refresh);
  }

  const [holding, setHolding] = useState('');
  const [staking, setStaking] = useState('');
  const [volume, setVolume] = useState('');
  const [timespan, setTimeSpan] = useState(1);
  const [showResult, setShowResult] = useState(false);
  const [reward, setReward] = useState(0);
  const [burnBalance, setBurnBalance] = useState(0);
  const [selfBalance, setSelfBalance] = useState(0);
  const [lpBalance, setLPBalance] = useState(0);
  const [staked, setStaked] = useState(0);

  const reflectionBalance = 999999999051 - (burnBalance + selfBalance + lpBalance);

  useEffect(() => {
    setShowResult(false);
  }, [holding, staking, volume]);

  useEffect(() => {
    getCalculatorData();
  }, []);

  const getCalculatorData = async () => {
    const web3 = new Web3(providerURL());
    const UFOContract = new web3.eth.Contract(Token.ABI, Token.Contract);
    const stakingContract = new web3.eth.Contract(StakingContract.ABI, StakingContract.Contract);

    setBurnBalance(parseInt(await UFOContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    setSelfBalance(parseInt(await UFOContract.methods.balanceOf('0x456548A9B56eFBbD89Ca0309edd17a9E20b04018').call()) / 10**18);
    setStaked(parseInt(await stakingContract.methods.UFOStaked().call()) / 10**18);

    setLPBalance(
      parseInt(await UFOContract.methods.balanceOf('0xbea0e55b82eb975280041f3b49c4d0bd937b72d5').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x5b002c8ad3c23b4021f75003fecf01a10b11f6ca').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x31c77e0519a0347aa547aeab6e866c30a1a32123').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x2cabcba08e69449f9acf3dd69f7a7cd2f9ddc0db').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x3ed0e39d9de5341ac511249517099c3e5d8b92bf').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0xd3a87bda2238ee28b424d38991df1fbadd2be666').call()) / 10**18 + 
      parseInt(await UFOContract.methods.balanceOf('0x1f2fa0f2cd4f603878d46d979370f82a91715fcc').call()) / 10**18 
    );
  };

  const calculateReward = async () => {
    const stakingFee = volume * 0.01;
    const reflectionFee = volume * 0.01;
    
    let reward = 0;

    if(staking > 0)
    {
      const rewardPerStaking = stakingFee / staked;
            reward += (rewardPerStaking * staking);
    }

    if(holding > 0) 
    {
      const rewardPerHolding = reflectionFee / reflectionBalance;
            reward += (rewardPerHolding * holding);
    }
    setReward(reward);
    setShowResult(true);
  };
  const [currency, setCurrency] = useState("USD");
  const handleCurrencyChange = (type) => {
    setCurrency(type);
    setVolume(""); 
  };
  return (
  <>
  <Menu />
  <section className="UFOSEC slideSec slideSecInner leftrightSecSpace">
    <div className="1 relative">
      <div className="row justify-content-between align-items-center">
        <div className="col-xl-7">
          <div className="sliderContent">
            <h1 className='good_times goldFont'  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="600"><img src="./images/ufo_logoName.svg" className="img-fluid logoNameInnerPage m-0 d-inline-block"/> Liquidity</h1>
            <p className="mt-0" data-aos="fade"  data-aos-delay="500" data-aos-duration="800">Easily add or remove liquidity to support trading, earn rewards , and strengthen the The Grays ecosystem.</p>
            <div className="bottomSliderBtn" data-aos="fade-right"  data-aos-delay="700" data-aos-duration="1000">
              <div className="d-flex gap-3 align-items-center">
                <button className="borderbtn mybtn" disabled={account ? 'disabled' :''} onClick={onConnect}>
                  <span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid" />
                </button>
                <a href="https://scan.pulsechain.com/address/0x456548A9B56eFBbD89Ca0309edd17a9E20b04018" target="_blank" rel="noopener noreferrer" className="mybtn underline text-white"><span>View Farming Contract</span></a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-5 slR">
          <div className="bottomSliderRight " data-aos="fade-left"  data-aos-delay="700" data-aos-duration="1000">
            <div className="bSRIN overHide">
              <div className="snPortal">
                <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                  <span className="fInter goldFont">Reward Calculator</span>
                  <div className="iconSR"><img src="./images/MathOperations.svg" className="img-fluid" /></div>
                </div>
              </div>
                <div className="row m-0 borderBottom">
                  <div className="col-md-6 col-xl-6 p-0">
                    <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Holding Amount</label>
                    <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                      <img className="img-fluid" src="./images/UFO_big_circle.svg" style={{width:'30px'}} />
                      <input
                        type="text"
                        className="nobginput p-0 w-100"
                        placeholder="0.00"
                        style={{ borderRadius: '0px', background: 'transparent', border: '0px', padding: '0px' }}
                        value={
                          holding === ""
                            ? ""
                            : Number(holding.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                              })
                        }
                        onChange={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          if (raw === "") {
                            setHolding("");
                            return;
                          }
                          if (isNaN(raw)) return;
                          const num = Math.min(Number(raw), Number(reflectionBalance));
                          setHolding(num.toString());
                        }}
                      />
                    </div>
                  </div>
                  </div>
                </div>
                <div className="col-md-6  col-xl-6 p-0">
                    <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">LPing Amount</label>
                    <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                        <img className="img-fluid" src="./images/UFO_big_circle.svg" style={{width:'30px'}} />
                        <input
                          type="text"
                          className="nobginput p-0 w-100"
                          placeholder="0.00"
                          style={{ borderRadius: '0px', background: 'transparent', border: '0px', padding: '0px' }}
                          value={
                            staking === ""
                              ? ""
                              : Number(staking.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setStaking("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(staked));
                            setStaking(num.toString());
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-xl-12 p-0">
                  <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange"> Enter Daily Volume ({currency})</label>
                    <div className="amountSTaking  inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                      {currency === "UFO" ? (
                          <img
                            src="./images/UFO_big_circle.svg"
                            className="img-fluid"
                            alt="icon"
                             style={{width:'auto', height: '30px'}}
                          />
                        ) : (
                          <img
                            src="./coinimages/0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07.png"
                            className="img-fluid"
                            alt="icon"
                             style={{width:'auto', height: '30px', filter: 'grayscale(1)'}}
                          />
                        )}
                      <input 
                        type="text" 
                        className="nobginput p-0  w-100" 
                         placeholder={currency === "UFO" ? "0.00 UFO" : "0.00 USD"}
                        style={{borderRadius:'0px',background:'transparent',border:'0px', padding:'0px'}} 
                        value={
                          volume === ""
                            ? ""
                            : Number(volume.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2
                              })
                        }
                        onChange={(e) => {
                          const raw = e.target.value.replace(/,/g, "");
                          if (raw === "" || !isNaN(raw)) {
                            setVolume(raw);
                          }
                        }}
                      />
                    </div>

                    <div className="d-flex gap-1">
                        <button style={{marginBottom:'0px'}} 
                          className={`spanSpecial ${currency === "UFO" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("UFO")}
                        >
                          UFO
                        </button>

                        <button style={{marginBottom:'0px'}} 
                          className={`spanSpecial ${currency === "USD" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("USD")}
                        >
                          USD
                        </button>
                      </div>
                  </div>
                </div>
                </div>
                <div className="col-md-12 col-xl-12 p-0">
                  <div className="boxes2">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Select Time Span</label>
                    <div className="MSelect d-flex gap-2">
                      <div className="relativeSelect w-100">
                        <select style={{padding: '8px 20px'}} className="form-control nobginput w-100" onChange={(e) => setTimeSpan(e.target.value)}>
                          <option value="1">Daily</option>
                          <option value="7">Weekly</option>
                          <option value="30">Monthly</option>
                          <option value="365">1 Year</option>
                          <option value="1825">5 Years</option>
                          <option value="3650">10 Years</option>
                        </select>
                        <i className="fa-solid fa-angle-down"></i>
                      </div>
                  </div>
                </div>
               </div>
              </div>
              <div className={showResult ? "p-2 borderBottom" : 'p-2'}>
                {
                   (holding > 0 || staking > 0) && volume > 0 ?
                   <>
                    <button  className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" onClick={() => calculateReward()}>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                   :
                   <>
                    <button className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" disabled>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                }
              </div>
              {
                showResult ?
                <>
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 borderBottom">
                      <div className="snPortal" style={{ padding: "26px 20px" }}>
                        <div className="">
                          <span className="fInter">Reward</span>
                          <h3 className="dollorValue value mt-0">
                            {
                              currency === "USD" ?
                              <>
                                <span className="val">{parseFloat((reward / ufoPrice) * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              </>
                              :
                              <>
                                <span className="val">{parseFloat(reward * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              </>
                            }
                            <span className="dollor2">UFO</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                     <div className="col-xl-12 col-lg-12">
                      <div className="snPortal" style={{ padding: "26px 20px" }}>
                        <div className="">
                          <span className="fInter">Reward</span>
                          <h3 className="dollorValue value mt-0">
                            <span className="dollor2">$</span>
                            {
                              currency === "USD" ?
                              <>
                                <span className="val">{reward > 0  ? parseFloat(reward  * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}</span>
                              </>
                              :
                              <>
                               <span className="val">{reward > 0 && ufoPrice > 0 ? parseFloat(reward * ufoPrice * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}</span>
                              </>
                            }
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
                :
                <>
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className='UFOSEC clippathSec padsec ProposalSec stakeSec StatsSec leftrightSecSpace'>
      <div className={`makPosBtnCenter ${isInSection ? "active" : ""}`}>
      </div>
    <div className="d-flex justify-content-between align-items-center">
      <h2  className="good_times goldFont">Manage Liquidity</h2>
    </div>
    <div className="statsALL">
      <div className="row">
        <div className="col-sm-12">
          <div className="subcontent SRTOP p-0">
            <div className="row">
              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/ptgccircle.svg"/></span>UFO / PTGC</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span className="">Notice: Token fees are applicable for this trading pair.</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOpTGC.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled PTGC</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOpTGC.pTGC / 10**18).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOpTGC.supply > 0 ? ((UFOpTGC.balance / UFOpTGC.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_PTGC')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOpTGC.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_PTGC')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>

              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/PLS.png"/></span>UFO / PLS</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span className="">Notice: Token fees are applicable for this trading pair.</span>
                    </div>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOPLS.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled PLS</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOPLS.PLS / 10**18).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOPLS.supply > 0 ? ((UFOPLS.balance / UFOPLS.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_PLS')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOPLS.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_PLS')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>

              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/HEX.png"/></span>UFO / HEX</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOHEX.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled HEX</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOHEX.HEX / 10**8).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOHEX.supply > 0 ? ((UFOHEX.balance / UFOHEX.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_HEX')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOHEX.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_HEX')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>


              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/HEXETH.png"/></span>UFO / HEX from Ethereum</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOHEXETH.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled HEX</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOHEXETH.HEXETH / 10**8).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOHEXETH.supply > 0 ? ((UFOHEXETH.balance / UFOHEXETH.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_HEXETH')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOHEXETH.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_HEXETH')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>


              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/INC.png"/></span>UFO / INC</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOINC.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled INC</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOINC.INC / 10**18).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOINC.supply > 0 ? ((UFOINC.balance / UFOINC.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_INC')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOINC.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_INC')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>

              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/PLSX.png"/></span>UFO / PLSX</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOPLSX.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled PLSX</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFOPLSX.PLSX / 10**18).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFOPLSX.supply > 0 ? ((UFOPLSX.balance / UFOPLSX.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_PLSX')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFOPLSX.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_PLSX')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>


              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative">
                    <h2 className="d-flex align-items-center"><span className="d-flex bothCoins">
                      <img className="img-fluid" src="./images/ptgc/ufologo_circle.svg" />
                      <img className="img-fluid" src="./images/DAI.png"/></span>UFO / DAI</h2>
                    <div className="perVal fInter d-flex align-items-center mt-3">
                      <span>&nbsp;</span>
                    </div>
                    <div className="row justify-content-between">
                      <div className="col-xl-8">
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled UFO</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFODAI.UFO / 10**18).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2,})}</span>
                          </h3>
                        </div>
                        <div className="mt-3">
                          <span className="perVal d-block">Pooled DAI</span>
                          <h3 className="dollorValue value  mt-0">
                            <span className="val f34">{parseFloat(UFODAI.DAI / 10**18).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="mt-3 text-xl-end">
                          <span className="perVal d-block">Your Share of Pool</span>
                          <h3 className="dollorValue value  mt-0 p-0">
                            <span className="val f34">{UFODAI.supply > 0 ? ((UFODAI.balance / UFODAI.supply) * 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }): '0.00'}%</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="d-flex justify-content-xl-end align-items-center">
                        <div className="someBtns SRTOP width-xl-100 d-flex gap-2 ">
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={account ? '' :'disabled'} onClick={ ()=> { addLiquidity('UFO_DAI')}}>
                            <span>Add Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/Coins.svg" />
                            </div>
                          </button>
                          <button className="someSnbtn d-flex w-auto align-items-center justify-content-center" disabled={UFODAI.balance > 0.01 && account ? '' :'disabled'} onClick={ ()=> { removeLiquidity('UFO_DAI')}}>
                            <span>Remove Liquidity</span>
                            <div className="iconSR">
                              <img className="img-fluid" src="./images/MathOperations.svg" />
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>        
                  </div>
                </div>
              </div>
              <div className="col-sm-6 bordercol">
                <div className="snpool snstakes">
                  <div className="relative text-center d-flex align-items-center justify-content-center">
                    <div>
                      <h1 className="good_times goldFont d-block h1rewards">Rewards</h1>
                      <p>Earn passive income  with UFO rewards.</p>
                      <Link to='/ufo-reward' className="borderbtn mybtn mt-2" style={{paddingLeft:'15px'}}>
                        <span>View Now</span> <img className="img-fluid" src="./images/circle_arrow.svg" style={{width:'25px'}} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <AddLiquidity modalIsOpen={addLiquidityModalOpen} closeModal={closeAddLiquidityModal} pair={currentPair} updatePage={updatePage}/>
  <RemoveLiquidity modalIsOpen={removeLiquidityModalOpen} closeModal={closeRemoveLiquidityModal} pair={currentPair} updatePage={updatePage}/>
  <TransactionStatus />
  <Footer />
  </>
  );
};

export default IndexSections;